<template lang='pug' src='./accessibility.pug'></template>

<script>
import Loader from 'components/loader/loader'

export default {
  name: 'Accessibility',
  computed: {
    props () {
      return this.$store.state.pages['getting-started']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader
  },
  data () {
    return {
      companyName: 'Pham Orthodontics', // Fill this in
      domain: "<a href='https://phamortho.com'>phamortho.com</a>", // Fill this in
      email: "<a href='mailto:westerville@phamortho.com'>westerville@phamortho.com</a>, <a href='mailto:marion@phamortho.com'>marion@phamortho.com</a>, <a href='mailto:springfield@phamortho.com'>springfield@phamortho.com</a>", // Fill this in
      phone: "<a href='tel:+17403622500'>740-362-2500</a>, <a href='tel:+17403862700'>740-386-2700</a>, <a href='tel:+19375250200'>937-525-0200</a>", // Fill this in
      formattedEmail: ''
    }
  },
  mounted () {
    this.formatEmail()
  },
  methods: {
    formatEmail () {
      this.formattedEmail = '<a aria-label="email ' + this.email + '" href="mailto:' + this.email + '">' + this.email + '</a>'
    }
  }
}
</script>



// WEBPACK FOOTER //
// accessibility.vue?38bf7ef6